import { getFormValues } from 'redux-form';
import { AxiosError } from 'axios';

import { FormsEnum } from 'app/shared/enums';
import { ThunkResult } from 'app/store/helpers';
import { TravelQuotationService } from 'app/services/travelQuotation.service';
import { TravelCalculationDataByModelPathsInterface } from 'app/shared/interfaces/TravelCalculationDataByModelPaths.interface';
import { getQuestions } from 'app/store/data/formsConfig';
import { selectTravelQuotation } from 'app/store/data/travelQuotation';
import { TagManagerService } from 'app/services/tagManager.service';
import { TravelQuotationInterface } from 'app/shared/interfaces/TravelQuotation.interface';

const addDataLayer = (quotationNumber: string, isPolandSelected: boolean) => {
  const dataLayer = {
    event: 'wykonanie_kalkulacji_success',
    numer_porownania: quotationNumber,
    typ_wynikow: isPolandSelected ? 'polska' : 'normal',
  };

  TagManagerService.addDataLayer(dataLayer);
};

export const onSubmitTravelForm = (
  onSuccess: () => void,
  onFail: (error: AxiosError) => void
): ThunkResult => (dispatch, getState) => {
  const state = getState();
  const formValues = getFormValues(FormsEnum.TravelForm)(state);
  const questions = getQuestions(state, FormsEnum.TravelForm);
  const travelQuotation = selectTravelQuotation(state);
  const data = TravelQuotationService.getValuesByModelPaths<TravelCalculationDataByModelPathsInterface>(
    formValues,
    questions,
    travelQuotation
  ) as TravelQuotationInterface;

  data.travelers.splice(Number(data.numberOfPersons), data.travelers.length);

  TravelQuotationService.requestForQuotationResults({
    quotationId: travelQuotation.id,
    data,
  })
    .then(() => {
      addDataLayer(travelQuotation.number, data.countryCodes?.includes('PL'));
      onSuccess();
    })
    .catch(onFail);
};
